module.exports = __webpack_public_path__ + "img/coral-1.13626ac0.png";